export const SET_COMPANY_PARAM = 'SET_COMPANY_PARAM';
export const FETCH_SCHEMES = 'FETCH_SCHEMES';
export const CREATE_SCHEME = 'CREATE_SCHEME';
export const EDIT_SCHEME = 'EDIT_SCHEME';
export const DELETE_SCHEME = 'DELETE_SCHEME';
export const EDIT_TEAM = 'EDIT_TEAM';
export const EDIT_USER = 'EDIT_USER';
export const DELETE_TEAMS = 'DELETE_TEAMS';
export const DELETE_USERS = 'DELETE_USERS';
export const ADD_USERS = 'ADD_USERS';
export const SEND_USERS_CREDENTIALS = 'SEND_USERS_CREDENTIALS';
export const LOCK_USERS = 'LOCK_USERS';
export const LOCK_TEAMS = 'LOCK_TEAMS';
export const FETCH_STARTUP_TEMPLATES = 'FETCH_STARTUP_TEMPLATES';
export const SET_STARTUP_TEMPLATE = 'SET_STARTUP_TEMPLATE';
export const DELETE_STARTUP_TEMPLATE = 'DELETE_STARTUP_TEMPLATE';
export const FETCH_CONFIG_USERS = 'FETCH_CONFIG_USERS';


export default {
  SET_COMPANY_PARAM,
  FETCH_SCHEMES,
  CREATE_SCHEME,
  EDIT_SCHEME,
  DELETE_SCHEME,
  EDIT_TEAM,
  EDIT_USER,
  DELETE_TEAMS,
  DELETE_USERS,
  ADD_USERS,
  SEND_USERS_CREDENTIALS,
  LOCK_USERS,
  LOCK_TEAMS,
  FETCH_STARTUP_TEMPLATES,
  SET_STARTUP_TEMPLATE,
  DELETE_STARTUP_TEMPLATE,
  FETCH_CONFIG_USERS,
};
